export default function Msi() {

    return(
        <>MSI</>
    )
}